import axios from "axios";
import { Message, Loading } from "element-ui";
import { tansParams, blobValidate } from "@/utils/ruoyi"
import { saveAs } from 'file-saver'
import errorCode from '@/utils/errorCode'

import store from '@/store'
let downloadLoadingInstance

// 创建 Axios 实例
const service = axios.create({
  // baseURL: "https://hkapi.domidesk.com",
  // baseURL: "https://yinheapi.yinheshujie.com/prod-api",
  baseURL: "https://nezha.csxuncong.com/prod-api",
  // baseURL: "http://192.168.2.21:10001",
  // baseURL: "http://47.239.159.228:8080",
  timeout: 300000,
  timeoutErrorMessage: "请求超时！",
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const token = store.getters.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.request.responseType ===  'blob' || response.request.responseType ===  'arraybuffer') {
      return res
    }
    if (res.code === 401) {
      Message.error("您的登录信息已过期，请重新登录！");
      store.dispatch('ExpireSession');
      location.href = '/login';
      return Promise.reject(new Error("未登录或登录已过期"));
    }

    if (res.code !== 200) {
      !response.config.noTip && Message.error(res.msg || "系统异常");
      return Promise.reject(new Error(res.msg || "Error"));
    }

    return res;
  },
  (error) => {
    // HTTP 层面拦截 401（如果后端直接返回 HTTP 401）
    if (error.response && error.response.status === 401) {
      Message.error("您的登录信息已过期，请重新登录！");
      store.dispatch('ExpireSession');
      location.href = '/login';
    } else {
      Message.error(error.response?.data?.msg || "网络连接失败，请刷新再试！");
    }
    return Promise.reject(error);
  }
);

// 通用下载方法
export function download(url, params, filename, config) {
  downloadLoadingInstance = Loading.service({ text: "正在下载数据，请稍候", spinner: "el-icon-loading", background: "rgba(0, 0, 0, 0.7)", })
  return service.post(url, params, {
    // transformRequest: [(params) => { return tansParams(params) }],
    headers: { 'Content-Type': 'application/json' },
    responseType: 'blob',
    ...config
  }).then(async (data) => {
    const isBlob = blobValidate(data)
    if (isBlob) {
      const blob = new Blob([data])
      saveAs(blob, filename)
    } else {
      const resText = await data.text()
      const rspObj = JSON.parse(resText)
      const errMsg = errorCode[rspObj.code] || rspObj.msg || errorCode['default']
      Message.error(errMsg)
    }
    downloadLoadingInstance.close()
  }).catch((r) => {
    console.error(r)
    Message.error('下载文件出现错误，请联系管理员！')
    downloadLoadingInstance.close()
  })
}

export default service;
